import { Permission } from '@cims-online/shared'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  Discipline,
  useDisciplinesTableContext,
} from '../../../../DisciplinesTableContext'
import { useSoftRemoveDsDisciplineMutation } from 'schema'

export function useRemove(): RemoveRowActionOptions<Discipline> {
  const { refetch } = useDisciplinesTableContext()
  const [remove] = useSoftRemoveDsDisciplineMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemoveDSDiscipline: {
        discipline: { name },
      },
    }) => simpleRemoveNotification(name),
  })
  return {
    disabled: ({ users, dsToDSDisciplines }) =>
      !!dsToDSDisciplines.length || !!users.length
        ? {
            message:
              'Disciplines cannot be deleted if they have any associated users or are associated with any Submittals',
          }
        : false,
    permission: Permission.RemoveRestoreDesignSubmittalDiscipline,
    onRemove: async ({ id }) => {
      await remove({ variables: { id } })
      refetch()
    },
  }
}
